// Глобальное состояние для сохранения прогресса клиентов
const clientProgressCache = new Map<string, Map<number, boolean>>();

// Функция для получения ключа кеша клиента
export const getClientCacheKey = (workoutId: number, clientId: number) => `${workoutId}-${clientId}`;

// Функция для сохранения прогресса клиента
export const saveClientProgress = (workoutId: number, clientId: number, exerciseId: number, isCompleted: boolean) => {
  const cacheKey = getClientCacheKey(workoutId, clientId);
  if (!clientProgressCache.has(cacheKey)) {
    clientProgressCache.set(cacheKey, new Map());
  }
  const clientCache = clientProgressCache.get(cacheKey)!;
  clientCache.set(exerciseId, isCompleted);
};

// Функция для получения прогресса клиента
export const getClientProgress = (workoutId: number, clientId: number, exerciseId: number): boolean | undefined => {
  const cacheKey = getClientCacheKey(workoutId, clientId);
  const clientCache = clientProgressCache.get(cacheKey);
  return clientCache?.get(exerciseId);
};

// Функция для очистки кеша клиента
export const clearClientCache = (workoutId: number, clientId: number) => {
  const cacheKey = getClientCacheKey(workoutId, clientId);
  clientProgressCache.delete(cacheKey);
};

// Функция для очистки кеша конкретного упражнения клиента
export const clearExerciseProgress = (workoutId: number, clientId: number, exerciseId: number) => {
  const cacheKey = getClientCacheKey(workoutId, clientId);
  const clientCache = clientProgressCache.get(cacheKey);
  if (clientCache) {
    clientCache.delete(exerciseId);
  }
};

// Функция для получения всех прогрессов клиента
export const getAllClientProgress = (workoutId: number, clientId: number): Map<number, boolean> | undefined => {
  const cacheKey = getClientCacheKey(workoutId, clientId);
  return clientProgressCache.get(cacheKey);
};

// Функция для очистки всех кешей тренировки
export const clearWorkoutCache = (workoutId: number) => {
  const keysToDelete: string[] = [];
  clientProgressCache.forEach((value, key) => {
    if (key.startsWith(`${workoutId}-`)) {
      keysToDelete.push(key);
    }
  });
  keysToDelete.forEach(key => clientProgressCache.delete(key));
}; 